import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { DeliveryInfo, ShippingAddress, ShippingAddressValue } from '../models';

export const shippingAddressesActions = createActionGroup({
    source: 'Shipping Addresses',
    events: {
        'Get Addresses': emptyProps(),
        'Get Addresses Success': props<{ items: ShippingAddress[]; current: ShippingAddress }>(),
        'Get Addresses Error': emptyProps(),

        'Set Address': props<{ value: ShippingAddressValue }>(),
        'Set Address Success': props<{ code: string }>(),
        'Set Address Error': emptyProps(),

        'Get Delivery Info': emptyProps(),
        'Get Delivery Info Success': props<{ data: DeliveryInfo }>(),
        'Get Delivery Info Error': emptyProps(),

        Clear: emptyProps(),
    },
});
